module.exports = __webpack_public_path__ + "static/media/mapa-a2.8782a81a.png";